import { createStyles, getSize, rem } from '@mantine/styles';
var sizes = {
  xs: rem(12),
  sm: rem(18),
  md: rem(24),
  lg: rem(34),
  xl: rem(42)
};
var useStyles = createStyles(function (theme, _ref, _ref2) {
  var color = _ref.color,
      transitionDuration = _ref.transitionDuration;
  var size = _ref2.size;
  var sizeValue = getSize({
    size,
    sizes
  });

  var _color = color || (theme.colorScheme === "dark" ? theme.white : theme.black);

  return {
    root: {
      borderRadius: theme.radius.sm,
      width: "calc(".concat(sizeValue, " + ").concat(theme.spacing.xs, ")"),
      height: "calc(".concat(sizeValue, " + ").concat(theme.spacing.xs, ")"),
      padding: "calc(".concat(theme.spacing.xs, " / 2)"),
      cursor: "pointer"
    },
    burger: {
      position: "relative",
      userSelect: "none",
      boxSizing: "border-box",
      "&, &::before, &::after": {
        display: "block",
        width: sizeValue,
        height: "calc(".concat(sizeValue, " / 12)"),
        backgroundColor: _color,
        outline: "".concat(rem(1), " solid transparent"),
        transitionProperty: "background-color, transform",
        transitionDuration: "".concat(transitionDuration, "ms"),
        "@media (prefers-reduced-motion)": {
          transitionDuration: theme.respectReducedMotion ? "0ms" : void 0
        }
      },
      "&::before, &::after": {
        position: "absolute",
        content: '""',
        left: 0
      },
      "&::before": {
        top: "calc((".concat(sizeValue, " / 3) * -1)")
      },
      "&::after": {
        top: "calc(".concat(sizeValue, " / 3)")
      },
      "&[data-opened]": {
        backgroundColor: "transparent",
        "&::before": {
          transform: "translateY(calc(".concat(sizeValue, " / 3)) rotate(45deg)")
        },
        "&::after": {
          transform: "translateY(calc(-".concat(sizeValue, " / 3)) rotate(-45deg)")
        }
      }
    }
  };
});
export default useStyles;